<template>
  <div
    class="institute-wrap text-start position-relative"
    :style="{
      backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/institute/${info.image})`,
    }"
  >
    <div
      class="institute-block position-relative"
      :class="{ 'pointer-events-none': eng }"
    >
      <div class="overlay"></div>
      <div class="slide-up position-absolute">
        <div class="institute h2-style w-100 h-100 mobile-h2">
          <div class="d-md-none">{{ info.nation }}</div>
          <div v-if="!eng">{{ info.title }}</div>
          {{ info.title_en }}
        </div>
        <div class="hint mobile-small" v-if="!eng">
          <div class="quota">招生名額：{{ info.quota }}名</div>
          <div class="speciality">專長：{{ info.expertise }}</div>
        </div>

        <div class="intro small-text" v-if="!eng">{{ info.intro }}</div>
        <div class="d-flex" v-if="!eng && info.link.length > 0">
          <a :href="info.link" class="tag-link" target="_blank"
            ><img :src="linkArrow" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';

export default {
  props: {
    info: { type: Object, required: true },
    eng: { type: Boolean, required: false },
  },
  data() {
    return {
      linkArrow,
      bg: this.image,
    };
  },
  computed: {
    seperatedName() {
      return this.info.name.split(' ');
    },
  },
};
</script>

<style lang="stylus" scoped>
.pointer-events-none
  pointer-events: none;

.institute-wrap
  // background-size: auto 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  // width: 100%;
  height: 480px;
  white-space: normal;
  transition: all 0.3s ease;

.overlay
  position: absolute;
  // bottom: 100%;
  left: 0;
  right: 0;
  background-color: rgba(244, 243, 238, 0.8);
  overflow: hidden;
  width: 100%;
  // height: 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;

.institute-block
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover
    // background-color: rgba(244, 243, 238, 0.8);
    .overlay
      opacity: 0.85;
      height: 100%;
      mix-blend-mode: alpha;
      transition: all 0.5s ease-out;

    .slide-up
      transition: all 0.5s ease-out;
      color: $monoc4;
      padding-top: 16px;
      // bottom: 100%;
      // transform: translateY(100%);

.slide-up
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: $monoc1;
  padding: 370px 16px 16px 16px;
  z-index: 500;
  transition: all 0.5s ease-in-out;

.intro
  margin-top: 24px;
  margin-bottom: 16px;
  text-align: justify;
  // display: none;

.tag-link
  margin-top: 24px;

  // display: none;
  img
    width: 36px;
    margin-left: 8px;
</style>
